import {
  RFQ_PROPOSAL_CARD_DATA,
  getRFQProposalChecklistURL,
} from 'global/checklists-helpers/RFQProposalChecklistHelper';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useRfqQuoteUrlParams from 'global/hooks/useRfqQuoteUrlParams';
import { useRFQDetailsPageStore } from 'store/pages/rfq/rfq-response/rfq-details/pageStore';
import DynamicFormFromJSON from 'components/common/form/DynamicFormFromJSON';
import ActionModal from '@insurancemenu/imenu-components-lib/dist/components/modals/ActionModal';
import { PageHeader } from '@insurancemenu/imenu-components-lib';
import { ModalType } from '@insurancemenu/imenu-components-lib/dist/helpers/ModalsHelper';
import { RFQ_DETAILS_DYNAMIC_FORM_TEST_ID, RFQ_SAVE_AND_EXIT_MODAL_TEST_ID } from '../constants';

const RFQDetailsContent: React.FC = observer(() => {
  const history = useHistory();
  const { periodId, cartId } = useRfqQuoteUrlParams();

  const {
    isLoading,
    form,
    dynamicForm,
    isStepCompleted,
    isExitModalVisible,
    getInitialData,
    completeStep,
    saveAnswersBeforeExit,
    openExitModal,
    closeExitModal,
  } = useRFQDetailsPageStore();

  useEffect(() => {
    void getInitialData(periodId, cartId);
  }, []);

  const onDefaultRedirect = (): void => {
    history.push(getRFQProposalChecklistURL({ periodId, cartId }));
  };

  const onRedirectBack = (): void => {
    if (isStepCompleted) {
      onDefaultRedirect();
    } else {
      openExitModal();
    }
  };

  const onUpdateAnswersOnly = async (): Promise<void> => {
    await saveAnswersBeforeExit(periodId, cartId);
    onDefaultRedirect();
  };

  const onCompleteStep = async (): Promise<void> => {
    await completeStep(periodId, cartId);
    onDefaultRedirect();
  };

  return (
    <>
      <PageHeader
        title={RFQ_PROPOSAL_CARD_DATA.RFQ_DETAILS.title}
        subtitle={RFQ_PROPOSAL_CARD_DATA.RFQ_DETAILS.text}
        onBackButtonClick={onRedirectBack}
      />
      <DynamicFormFromJSON
        dynamicForm={dynamicForm}
        form={form}
        loading={isLoading}
        isFormCompleted={isStepCompleted}
        onCompleteForm={onCompleteStep}
        completeBtnText={isStepCompleted ? 'Update' : 'Complete'}
        onBack={onRedirectBack}
        data-test-id={RFQ_DETAILS_DYNAMIC_FORM_TEST_ID}
      />
      <ActionModal
        show={isExitModalVisible}
        title="Would you like to save changes before exiting?"
        actionButtonText="Save and Exit"
        closeButtonText="Cancel"
        onClose={closeExitModal}
        onAction={onUpdateAnswersOnly}
        modalType={ModalType.NOTIFICATION}
        data-test-id={RFQ_SAVE_AND_EXIT_MODAL_TEST_ID}
      />
    </>
  );
});

export default RFQDetailsContent;
